import { AppState } from "@core/store/reducers";
import { createSelector } from "@ngrx/store";

const selectSpinnerStatus = (state: AppState) => state.spinner;
export const getSpinnerStatus = createSelector(selectSpinnerStatus, (state) => state.isShow);